import { render } from "./RedFlushApplyModal.vue?vue&type=template&id=c6ca2a4c&scoped=true&ts=true"
import script from "./RedFlushApplyModal.vue?vue&type=script&lang=ts"
export * from "./RedFlushApplyModal.vue?vue&type=script&lang=ts"

import "./RedFlushApplyModal.vue?vue&type=style&index=0&id=c6ca2a4c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6ca2a4c"]])

export default __exports__